import { CustomModal } from '@components'

import {
  Button, 
  ModalContent, 
  ModalHeader, 
  ModalBody, 
  ModalFooter, 
} from '@heroui/react'

import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline"
import PropTypes from 'prop-types'

const DeleteConfirmationModal = ({
  children,
  description,
  handleClose, 
  handleDelete,  
  isDeleting = false,
  subTitle,
  title,
}) => (
  <CustomModal
    isOpen
    size="2xl"
    handleClose={isDeleting ? undefined : handleClose}
    scrollBehavior="outside"
  >
    <ModalContent>
      <ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>

      <ModalBody>
        <div className="flex items-start gap-2 py-5">
          <QuestionMarkCircleIcon className="w-16 h-16 shrink-0 text-content2-foreground" />
        
          <div>
            {subTitle && (
              <h2 className="text-xl font-semibold">{subTitle}</h2>
            )}

            {description && (
              <p className="text-content2-foreground">{description}</p>
            )}

            {children}
          </div>
        </div>                
      </ModalBody>

      <ModalFooter>
        <div className="flex justify-between w-full">
          <Button onPress={handleClose} isDisabled={isDeleting}>Cancel</Button>
          <Button color="danger" onPress={handleDelete} isLoading={isDeleting}>Delete</Button>
        </div>
      </ModalFooter>
    </ModalContent>
  </CustomModal>
)

DeleteConfirmationModal.propTypes = {
  children: PropTypes.node,
  description: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isDeleting: PropTypes.bool,
  subTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export { DeleteConfirmationModal }